import TitleBlock from '@anm/components/TitleBlock';
import { AlertWrapper } from '@anm/components/notification/Alert';
import { flexColumn, flexRow, media } from '@anm/styles/helpers';
import styled from 'styled-components';

const infoTextOnMobile = media.phone`
  font-size: 12px;
  line-height: 20px;
`;

export const InfoText = styled.span`
  color: #919eaa;
  font-size: 16px;
  line-height: 25px;
  font-weight: normal;
  ${infoTextOnMobile};
`;

const titleOnMobile = media.phone`
  ${flexColumn};
  ${InfoText} {
    margin-left: 0;
    margin-top: 10px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  margin-top: 4px;
  margin-bottom: 17px;
  ${InfoText} {
    padding-top: 5px;
    margin-left: 19px;
  }
  ${titleOnMobile};
`;

export const LimitTitle = styled(TitleBlock)`
  width: unset;
  margin-bottom: 0 !important;
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 20px;
    line-height: 32px;
    font-weight: normal;
  }
`;

const trafficContentOnMobile = media.phone`
  ${InfoText} {
    margin-left: 0;
    margin-top: 7px;
  }
`;

export const TrafficContent = styled.div`
  ${flexRow};
  justify-content: space-between;
  ${trafficContentOnMobile};
`;

export const IndicatorUsage = styled.div<{ right: number }>`
  width: 100%;
  height: 8px;
  margin-top: 13px;
  overflow: hidden;
  position: relative;
  background: #ebeef5;
  &:after {
    content: '';
    left: 0;
    height: 100%;
    position: absolute;
    background: var(--blue_100);
    right: ${({ right }) => right}%;
  }
`;

const rowWrapperOnMobile = media.phone`
  padding: 22px 20px 30px;
  ${TitleWrapper} {
    margin-top: 13px;
    margin-bottom: 3px;
  }
  ${IndicatorUsage} {
    margin-top: 4px;
  }
`;

export const LimitRowWrapper = styled.div`
  ${flexColumn};
  padding: 22px 29px 39px 31px;
  border-bottom: 1px solid #ccdde6;
  ${AlertWrapper} {
    ${flexColumn};
    color: #292a2b;
    font-size: 14px;
    min-height: 45px;
    margin: 20px 0 0;
    p {
      margin: 0;
    }
  }
  ${rowWrapperOnMobile};
`;

const Wrapper = styled.div`
  margin-top: 16px;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid #ccdde6;
  box-shadow: 0 2px 10px rgba(1, 83, 130, 0.1);
`;

export default Wrapper;
